module.exports = __webpack_public_path__ + "img/Ardunic Elements-09.904bdf5c.svg";